/**
 * Landing — unauthenticated portal root.
 *
 * Not in the mockups — synthesized per rcp-module-v3.md gap. Provides two
 * clear paths: "Apply Now" (new customer) and "Sign in" (existing).
 */

import { Link } from 'react-router';
import { ShieldCheck, UserPlus, LogIn } from '@retail-ops/panel-shell/fi';

export function Landing(): JSX.Element {
  return (
    <>
      <section className="card" style={{ padding: 32 }}>
        <h1 tabIndex={-1}>Welcome to your Phelps County Bank portal</h1>
        <p style={{ fontSize: 16, color: 'var(--ink-700)', marginBottom: 24 }}>
          Open a new account online in minutes, or sign in to check the status
          of an application, upload documents, or manage your appointment.
        </p>
        <div style={{ display: 'flex', gap: 16, flexWrap: 'wrap' }}>
          <Link to="/apply/start" className="btn btn-primary">
            <UserPlus aria-hidden="true" size={18} />
            Apply now
          </Link>
          <Link to="/auth/signin" className="btn btn-secondary">
            <LogIn aria-hidden="true" size={18} />
            Sign in with email
          </Link>
        </div>
      </section>
      <section className="card">
        <h2>
          <ShieldCheck aria-hidden="true" size={18} style={{ marginRight: 8, verticalAlign: '-3px' }} />
          Safe and simple
        </h2>
        <ul style={{ paddingLeft: 20, margin: 0 }}>
          <li>No passwords to remember — we send a one-time code to your email.</li>
          <li>Your information is encrypted in transit and at rest.</li>
          <li>Questions? Call <a href="tel:15733645202">573-364-5202</a> during business hours.</li>
        </ul>
      </section>
    </>
  );
}
